import { ADMIN_HOSTEL_SECTION, ADMIN_NAV_SECTIONS } from "./adminWorkflow";

/** Sidebar modules — one checkbox disables the whole menu section. */
export const ADMIN_MODULE_OPTIONS = [
    {
        id: "start",
        label: "Home & overview",
        summary: "Office dashboard, analytics, EMIS reports",
    },
    {
        id: "setup",
        label: "Set up the school",
        summary: "Classes, subjects, staff, school page",
    },
    {
        id: "students",
        label: "Students",
        summary: "Enrolment, lists, rollover, complaints",
    },
    {
        id: "daily",
        label: "Every school day",
        summary: "Notices, attendance, marks review, schemes, leave",
    },
    {
        id: "exams",
        label: "Exams & results",
        summary: "Results records, CA, MANEB, report cards",
    },
    {
        id: "fees",
        label: "School fees",
        summary: "Structures, collection, defaulters, reports",
    },
    {
        id: "expenses",
        label: "School expenses",
        summary: "Expense book, budgets, summaries",
    },
    {
        id: "planning",
        label: "Timetable & calendar",
        summary: "Timetables, academic years, school calendar",
    },
    {
        id: "library",
        label: "Library & TLMs",
        summary: "Term resources and library inventory",
    },
    {
        id: "infrastructure",
        label: "Infrastructure & assets",
        summary: "Facilities, equipment, maintenance",
    },
    {
        id: "hostels",
        label: "Hostels & boarding",
        summary: "Dormitories and boarder lists",
    },
];

export const KNOWN_ADMIN_MODULES = ADMIN_MODULE_OPTIONS.map((module) => module.id);

const KNOWN_MODULE_SET = new Set(KNOWN_ADMIN_MODULES);

const ALL_NAV_SECTIONS = [...ADMIN_NAV_SECTIONS, ADMIN_HOSTEL_SECTION];

/** Map legacy per-feature ids to sidebar modules (for old saved preferences). */
const LEGACY_FEATURE_TO_MODULE = {
    dashboard: "start",
    analytics: "start",
    reports: "start",
    classes: "setup",
    subjects: "setup",
    teachers: "setup",
    communication: "setup",
    students: "students",
    promotion: "students",
    attendance: "daily",
    notices: "daily",
    resources: "daily",
    exams: "exams",
    "ca-assessment": "exams",
    fees: "fees",
    budget: "expenses",
    calendar: "planning",
    timetable: "planning",
    library: "library",
};

export function resolveAdminNavModule(route) {
    const path = route.split("?")[0];

    for (const section of ALL_NAV_SECTIONS) {
        if (section.items.some((item) => item.match(path))) {
            return section.id;
        }
    }

    return null;
}

export function migrateLegacyFeaturesToModules(enabledFeatures) {
    if (!Array.isArray(enabledFeatures)) return [];
    const modules = new Set();
    enabledFeatures.forEach((featureId) => {
        const moduleId = LEGACY_FEATURE_TO_MODULE[featureId] || featureId;
        if (KNOWN_MODULE_SET.has(moduleId)) {
            modules.add(moduleId);
        }
    });
    return [...modules];
}

export function normalizeModuleId(value) {
    const moduleId = String(value || "").trim();
    return KNOWN_MODULE_SET.has(moduleId) ? moduleId : null;
}
